export default __webpack_public_path__ + "static/media/marcarab-tr.da571219.png";